import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Switch } from '@progress/kendo-react-inputs'
import { Label, Error, Hint } from '@progress/kendo-react-labels'

const FormSwitch = (fieldRenderProps: FieldRenderProps) => {
  const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, required, value, defaultChecked, ...others } = fieldRenderProps
  const showValidationMessage = touched && validationMessage
  const showHint = !showValidationMessage && hint
  const hintId = showHint ? `${id}_hint` : ''
  const errorId = showValidationMessage ? `${id}_error` : ''


  return (
    <div id='FormSwitchPage'>
      <FieldWrapper>
        {label &&
          <Label className='mb-1' editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
            {required &&
              <span className='text-danger'>*</span>
            }
            {label} &nbsp;
            {
              showValidationMessage &&
              <Error id={errorId}>{validationMessage}</Error>
            }
          </Label>
        }
        <div className='k-form-field-wrap'>
          <Switch
            valid={valid}
            id={id}
            disabled={disabled}
            ariaDescribedBy={`${hintId} ${errorId}`}
            defaultChecked={defaultChecked ?? value}
            value={true}
            {...others}
          />
          {
            showHint &&
            <Hint id={hintId}>{hint}</Hint>
          }
        </div>
      </FieldWrapper>
    </div>
  )
}

export default FormSwitch